<template>
	<div>
		<slot>Set content as inline template.</slot>
	</div>
</template>

<script>
	import plyr from 'plyr';

	export default {
		data() {
			return {
				data: null,
				plyrInstance: null,
			}
		},
		mounted() {
			this.$root.$on('play', item => {
				this.data = item;
				this.plyrInstance.source({
					type: 'audio',
					sources: [{
						src: this.route('api.audio.source', this.data.source),
						type: 'audio/mp3'
					}]
				});
				this.plyrInstance.play();
			});
			this.$root.$on('select', item => {
				this.plyrInstance.stop();
			});
			this.plyrInstance = plyr.setup(document.getElementById('audio-player'))[0];
			// this.plyrInstance.on('canplay', event => {
			//   	this.plyrInstance.play();
			// });
		}
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AudioPlayer.vue